import { FocusableOption } from '@angular/cdk/a11y';
import {
  Directive,
  ElementRef,
  Input,
  HostBinding,
  HostListener,
  EventEmitter,
  Output,
} from '@angular/core';
@Directive({
  selector: '[snNavigableListItem]',
  host: { tabindex: '-1' },
})
export class NavigableListItemDirective implements FocusableOption {
  @Input('snNavigableListItem')
  public label?: string;

  // eslint-disable-next-line @angular-eslint/no-output-rename
  @Output('navSelection')
  public readonly selectedChange = new EventEmitter<void>();

  @Output()
  public readonly selected = new EventEmitter<void>();

  @Output()
  public readonly focused = new EventEmitter<void>();

  @HostBinding('tabindex')
  public tabIndex;

  constructor(private readonly element: ElementRef) {}

  @HostListener('focus', ['$event'])
  public focusEvent(event: FocusEvent): void {
    this.focused.emit();
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  @HostListener('click', ['$event'])
  public manage(event: KeyboardEvent): void {
    this.selected.emit();
  }

  public getLabel(): string {
    return this.label || '';
  }
  public focus(): void {
    (this.element.nativeElement as HTMLElement).focus();
  }
}
